import { siteData } from "../data/mock";
import { Sparkles } from "lucide-react";

export const WhiteningSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Visual */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img
                  src={siteData.images.doctorPhoto}
                  alt="Clareamento Dental"
                  className="w-full h-[420px] lg:h-[480px] object-cover object-center lg:object-[center_70%]"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="text-sm font-semibold uppercase tracking-wider mb-3 block" style={{ color: '#85BCFF' }}>
              Estética
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4 leading-tight">
              {siteData.whitening.title}
            </h2>
            <p className="text-lg font-medium mb-2" style={{ color: '#85BCFF' }}>
              {siteData.whitening.subtitle}
            </p>
            <p className="text-base text-slate-600 mb-8 leading-relaxed">
              {siteData.whitening.description}
            </p>

      
          </div>
        </div>
      </div>
    </section>
  );
};
